<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.engineeringplan_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/v4ward/engineering/engineeringplan";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    searchShow: true,
                    searchMenuSpan: 6,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    dialogClickModal: false,
                    column: [
                                {
                                    label: "主键",
                                    prop: "id",
                                    rules: [{
                                        required: true,
                                        message: "请输入主键",
                                        trigger: "change"
                                    }]
                                },
                                {
                                  label: "医院id",
                                  prop: "projectId",
                                  rules: [{
                                      required: true,
                                      message: "请输入立项id",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "工程项目id",
                                  prop: "engineeringId",
                                  rules: [{
                                    required: false,
                                    message: "请输入立项id",
                                    trigger: "change"
                                  }]
                                },
                                {
                                  label: "招标文件上传",
                                  prop: "bidFileUploadDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择招标文件上传",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "招标审批完成",
                                  prop: "bidApproveFinishDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择招标审批完成",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "开标/议标日期",
                                  prop: "bidOpenDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择开标/议标日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "商务谈判日期",
                                  prop: "businessNegotiationDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择商务谈判日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "中标通知日期",
                                  prop: "bidWinningNoticeDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择中标通知日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "合同会签日期",
                                  prop: "contractCountersignDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择合同会签日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "合同签订日期",
                                  prop: "contractSignDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择合同签订日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "开工日期",
                                  prop: "workStartDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择开工日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "竣工日期",
                                  prop: "workFinishDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择竣工日期",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "结算资料送审",
                                  prop: "settlementDataSubmitDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择结算资料送审",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "审计报告",
                                  prop: "auditReportDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择审计报告",
                                      trigger: "change"
                                  }]
                                },
                                {
                                  label: "质保金支付",
                                  prop: "qualityGuaranteePayDate",
                                  type: 'date',
                                  format: 'yyyy-MM-dd',
                                  valueFormat: 'yyyy-MM-dd',
                                  rules: [{
                                      required: false,
                                      message: "请选择质保金支付",
                                      trigger: "change"
                                  }]
                                },
                              ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.engineeringplan_add, false),
                    viewBtn: this.vaildData(this.permission.engineeringplan_view, false),
                    delBtn: this.vaildData(this.permission.engineeringplan_delete, false),
                    editBtn: this.vaildData(this.permission.engineeringplan_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
